import _ from 'lodash';
export default (min, max) => {
    if (_.isNaN(min) || _.isNaN(max)) {
        return 0;
    }

    return Math.floor(Math.random() * (max - min + 1)) + min;
};
